import React, { useEffect, useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { useConfirm } from "material-ui-confirm";
import { useSnackbar } from "notistack";
import { UsuarioFiltroAcesso } from "../../../Models/Cadastros/Usuario/UsuarioFiltroAcesso";
import { UsuarioFiltroAcessoService } from "../../../Services/Cadastros/Usuario/UsuarioFiltroAcessoService";
import InlineSearchComponent from "../../../Components/Forms/InlineSearchComponent";
import NumberFieldComponent from "../../../Components/Forms/NumberFieldComponent";
import DataGridCrudComponent from "../../../Components/Forms/DataGridCrudComponent";

const UsuarioFiltroAcessoPartial = (props: any) => {
    const [usuarioFiltroAcesso, setUsuarioFiltroAcesso] = useState<any>(new UsuarioFiltroAcesso());
    const [usuarioFiltroAcessos, setUsuarioFiltroAcessos] = useState<any[]>([]);
    const confirm = useConfirm();
    const { enqueueSnackbar } = useSnackbar();
    const usuarioFiltroAcessoService = new UsuarioFiltroAcessoService()

    const usuarioFiltroAcessoColunas: GridColDef[] = [
        { field: 'origem_nome', headerName: 'Origem', minWidth: 200, flex: 0.2, },
        { field: 'destino_nome', headerName: 'Destino', minWidth: 200, flex: 0.2, },
        { field: 'transportador_nome', headerName: 'Transportador', minWidth: 200, flex: 0.2, },
        { field: 'valor_minimo', headerName: 'Mínimo', minWidth: 150, flex: 0.1, },
        { field: 'valor_maximo', headerName: 'Máximo', minWidth: 150, flex: 0.1, },
    ];

    useEffect(() => {
        if (props.usuario == null) {
            return;
        }

        loadDados();
    }, [props.usuario]);

    function loadDados() {
        props.usuario.usuario_filtro_acessos = props.usuario.usuario_filtro_acessos ?? [];
        setUsuarioFiltroAcessos(usuarioFiltroAcessoService.selecionarValidos(props.usuario.usuario_filtro_acessos));
    }

    function editar(id: any) {
        let entity = props.usuario.usuario_filtro_acessos?.filter((e: any) => e.id == id)[0];
        setUsuarioFiltroAcesso(JSON.parse(JSON.stringify(entity)));
    }

    function salvar() {
        let response = usuarioFiltroAcessoService.salvar(usuarioFiltroAcesso, props.usuario.usuario_filtro_acessos);
        if (!response.valid) {
            enqueueSnackbar(response.message, {variant: 'error'});
            return;
        }

        props.usuario.usuario_filtro_acessos = response.entities;
        loadDados();
        cancelar();
        enqueueSnackbar('Registro salvo com sucesso!', {variant: 'success'});
    }

    async function apagar(id: any) {
        await confirm({ title: "Deseja realmente apagar este registro?" });

        let response = usuarioFiltroAcessoService.apagar(id, props.usuario.usuario_filtro_acessos);
        if (!response.valid) {
            enqueueSnackbar(response.message, {variant: 'error'});
            return;
        }

        props.usuario.usuario_filtro_acessos = response.entities;
        loadDados();
        enqueueSnackbar('Registro apagado com sucesso!');
    }

    function cancelar() {
        setUsuarioFiltroAcesso(new UsuarioFiltroAcesso());
    }
    
    return (
        <div>
            <DataGridCrudComponent
                model={usuarioFiltroAcesso}
                save={salvar}
                cancel={cancelar}
                labelSave='Salvar'
                gridEdit={editar}
                gridDelete={apagar}
                gridRows={usuarioFiltroAcessos}
                gridColumns={usuarioFiltroAcessoColunas}
                gridHideFooter={true}
                gridFieldId='id'
                gridHeight={500}>
                <div className="col-md-4 mb-3">
                    <InlineSearchComponent
                        id='combo_filtro_origem'
                        label='Filtro Origem'
                        urlApi='buscaComboEmpresas'
                        valueField='id'
                        textField='nome_completo'
                        model={usuarioFiltroAcesso}
                        modelField='origem_id'
                        modelFieldName='origem_nome' />
                </div>

                <div className="col-md-4 mb-3">
                    <InlineSearchComponent
                        id='combo_filtro_destino'
                        label='Filtro Destino'
                        urlApi='buscaComboEmpresas'
                        valueField='id'
                        textField='nome_completo'
                        model={usuarioFiltroAcesso}
                        modelField='destino_id'
                        modelFieldName='destino_nome' />
                </div>

                <div className="col-md-4 mb-3">
                    <InlineSearchComponent
                        id='combo_filtro_transportador'
                        label='Filtro Trasportador'
                        urlApi='buscaComboEmpresas'
                        valueField='id'
                        textField='nome_completo'
                        model={usuarioFiltroAcesso}
                        modelField='transportador_id'
                        modelFieldName='transportador_nome' />
                </div>

                <div className="col-md-3 mb-3">
                    <NumberFieldComponent label="Valor Mínimo" model={usuarioFiltroAcesso} field='valor_minimo' />
                </div>

                <div className="col-md-3 mb-3">
                    <NumberFieldComponent label="Valor Máximo" model={usuarioFiltroAcesso} field='valor_maximo' />
                </div>
            </DataGridCrudComponent>
        </div>
    );
}

export default UsuarioFiltroAcessoPartial;